module.exports = __webpack_public_path__ + "img/3_d.04940c18.jpg";